export default __webpack_public_path__ + "static/media/prepost1.b7b97b94.png";